export default __webpack_public_path__ + "static/media/step2.2a539c56.svg";